<template>
  <div class="property-engagement">
    <div class="property-engagement__header">
      <div class="property-engagement__title">
        <h4>Known Consumer Reach and Engagement by Property</h4>
      </div>
      <div class="property-engagement__legend">
        <graph-key :graph-key-items="keyItems" :flex="true"></graph-key>
      </div>
      <div class="property-engagement__sort">
        Sort By:
        <template v-for="(s, index) in sorts">
          <span v-if="index !== 0"> | </span>
          <a :class="{'active': (currentSort.name === s.name)}" @click.prevent="currentSort = s" href="#">{{ s.name }}</a>
        </template>
      </div>
    </div>
    <div class="property-engagement__graph-container">
      <property-engagement-graph :chart-data="chartData" class="property-engagement__graph"></property-engagement-graph>
    </div>
  </div>
</template>

<script>
  import PropertyEngagementGraph from './PropertyEngagementReachGraph'
  import GraphKey from '@/appComponents/oldWorkbench/graphKey/GraphKey'
  import { transformReachDataForGraph } from '@/appComponents/workbench/lasGraphs/chartDataHelpers'
  import { orderBy } from 'lodash'

  let sorts = [
    {
      name: 'Alphabetical',
      sortByKeys: [['name'], ['asc']]
    },
    {
      name: 'Engagement',
      sortByKeys: [['engagement', 'name'], ['desc', 'asc']]
    },
    {
      name: 'Reach',
      sortByKeys: [['reach', 'name'], ['desc', 'asc']]
    }
  ]

  export default {
    components: {
      PropertyEngagementGraph,
      GraphKey
    },
    props: [
      'brands'
    ],
    data () {
      return {
        sorts,
        currentSort: sorts[0],
        keyItems: [
          {
            color: 'rgba(0, 82, 231, 0.4)',
            body: 'Engagement'
          },
          {
            color: 'rgba(0, 82, 231, 1)',
            body: 'Reach'
          }
        ]
      }
    },
    computed: {
      chartData () {
        let sortedData = orderBy(this.brands, ...this.currentSort.sortByKeys)
        return transformReachDataForGraph(sortedData)
      }
    }
  }
</script>

<style lang="scss">
  $header-height: 40px;

  .property-engagement {
    width: 100%;
    font-size: rem(13);
    line-height: rem(20);

    h4 {
      margin: 0 0 rem(10) 0;
      text-transform: uppercase;
    }

    p {
      margin: 0 0 rem(10);
    }

    &__header {
      display: flex;
      height: $header-height;
    }

    &__title {
      flex: 1 1 200%;
      line-break: strict;
      word-break: keep-all;
    }

    &__legend {
      flex: 1 1 100%;
    }

    &__sort {
      flex: 0 0 auto;

      a {
        color: color(grays, dark);
        text-decoration: none;
        padding: 0 6px;

        &.active {
          color: color(blues, turner);
          text-decoration: underline;
        }
      }
    }

    &__graph-container {
      max-width: 100%;
      height: calc(100% - #{$header-height});
      overflow-x: auto;
      overflow-y: hidden;
    }

    &__graph {
      min-width: 1600px;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// PropertyEngagementReach.vue?dea04e62